import { Component, Input, OnInit , TemplateRef, ViewChild, Output, EventEmitter, ChangeDetectorRef,} from '@angular/core';
import { CandidateActionService } from 'src/app/_services/candidate-action.service';
import { CandidateService } from 'src/app/_services/candidate.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CandidateNoteComponent } from '../../candidate-note/candidate-note.component';

declare const clevertap;

@Component({
  selector: 'app-slider-notes-tab',
  templateUrl: './slider-notes-tab.component.html',
  styleUrls: ['./slider-notes-tab.component.scss']
})
export class SliderNotesTabComponent implements OnInit {
  @Input() candidateId :any
  @Input() candidatedata;
  allNotes:any=[]
  note: any
  notesdata: string;
  successMessage: string =''
  errorMessage: string =''
  @ViewChild('successModal') successModal: TemplateRef<any>;
  deletenotedata: any
  @Output() passEntryEvent: EventEmitter<any> = new EventEmitter();
  isLoggedinUserIsAdmin : boolean =false
  isLoggedInuserCreatedNote : number 
  loggedinuserfirstname : any
  loggedinuserlastname : any 
  statusMessage : string = ''
  constructor( public candidateservice: CandidateService, private localstorageservice: LocalStorageService, private candidateactionservice: CandidateActionService, public modalService: NgbModal) { }

  ngOnInit(): void {
    //this.allNotes = this.candidatedata.notes
    //this.getCandidateDetails(this.candidateId)
    this.isLoggedinUserIsAdmin = this.localstorageservice.getItem('role') =='team admin' ? true :false
    this.isLoggedInuserCreatedNote = this.localstorageservice.getItem('userid')
    this.loggedinuserfirstname = this.localstorageservice.getItem('ufname')
    this. loggedinuserlastname = this.localstorageservice.getItem('ulname')

  }
  getCandidateDetails(candidateId) {
    this.candidateservice.getCandidateDetails(candidateId).subscribe((res: any) => {
      if (res.status == 'success') {
        let response = res.data.candidatedetails
        this.allNotes = response.notes
      }
    })
  }

  saveCandidateNote() {
    let notesObj = {}
    this.notesdata = this.note;
    if (this.notesdata != null && this.notesdata != '') {
      if (this.note) {
        notesObj = {
          "editdetails": {
            "note": this.notesdata.replace(/'/g, "''"),
            "updatedby": this.localstorageservice.getItem('userid'),
            "notetype": "note"
          },
          "noteid": this.note.noteid,
          "candidatenumber": this.candidatedata.basicdetails[0].candidatenumber,
          "activitylog": {
            "action": "update",
            "type": "note",
            "tablename": "candidatenotes",
            "primarykeyid": this.note.noteid,
            "updatedfieldname": "notes",
            "userid": this.localstorageservice.getItem('userid'),
            "createdby": this.localstorageservice.getItem('userid'),
            "oldvalue": this.note.note.replace(/'/g, "''"),
            "newvalue": this.notesdata.replace(/'/g, "''")
          }
        }
        this.candidateactionservice.editCandidateNote(notesObj).subscribe((res: any) => {
          if (res.status == "success") {
            //this.passEntry.emit('updated')
            //- Clevertap Add notes event
            let ctObj = {
              "Name": this.candidatedata.basicdetails[0].firstname + " " + this.candidatedata.basicdetails[0].lastname,
              "Job title": this.candidatedata.basicdetails[0].jobtitle,
              "Company Name": this.candidatedata.basicdetails[0].companyname,
              "Source": this.candidatedata.basicdetails[0].source,
              "Location": this.candidatedata.basicdetails[0].locationname
            }
            this.cleverTapEvent("Notes", ctObj);
            this.toastmessage('Notes edited successfully', 'success')
          }
          else {
            this.toastmessage('Something went Wrong', 'error')
          }
        })

      }
      else {
        //for single candidate 
        if (this.candidatedata) {
          notesObj = {
            notes: [{
              note: {
                candidatenumber: "'" + this.candidatedata.basicdetails[0].candidatenumber + "'",
                createdby: this.localstorageservice.getItem('userid'),
                note: "'" + this.notesdata.replace(/'/g, "''") + "'",
                notetype: "'note'"
              },
              activitylog: {
                userid: this.localstorageservice.getItem('userid'),
                action: "'create'",
                tablename: "'candidatenote'",
              }
            }]
          }
        } 
        this.candidateactionservice.AddCandidateNote(notesObj).subscribe((res: any) => {
          if (res.status == 'success') {
              let ctObj = {
                "Name": this.candidatedata.basicdetails[0].firstname + " " + this.candidatedata.basicdetails[0].lastname,
                "Job title": this.candidatedata.basicdetails[0].jobtitle,
                "Company Name": this.candidatedata.basicdetails[0].companyname,
                "Source": this.candidatedata.basicdetails[0].source,
                "Location": this.candidatedata.basicdetails[0].locationname
              }
              this.cleverTapEvent("Notes", ctObj);
              this.toastmessage('Notes added successfully', 'success')
          } else {
            this.toastmessage('Something went Wrong', 'error')
          }
          
        })
    }
  }
  }

  cleverTapEvent(eventName, data) {
    clevertap.event.push(eventName, data);
    console.log(eventName + " CT event");
  }

  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error'){
      this.errorMessage = message;
      setTimeout(() => this.errorMessage = '', 5000);
    }
  }

  editnotes(note) {
    this.note = note.note;
    const modalRef = this.modalService.open(CandidateNoteComponent, { size: 'xs' as 'lg', centered: true });
    modalRef.componentInstance.editnoteid = note.candidatenoteid;
    modalRef.componentInstance.noteforCandidate = this.candidatedata.basicdetails[0]
    
    modalRef.componentInstance.passEntry.subscribe((x) => {
      if (x == 'noteAdded') {
        this.toastmessage('Notes Added for Selected Candidate Succesfully', 'success')
        this.passEntryEvent.emit('deleted')
      } else if (x == 'error') {
        this.toastmessage('Something went Wrong, Please try again in a minute', 'error')
      } else if( x == 'updated'){
        this.toastmessage('Notes edited for Selected Candidate Succesfully', 'success')     
        this.passEntryEvent.emit('deleted')
      }
    })
  }

  openAddNOtesModal(candidate?) {
    const modalRef = this.modalService.open(CandidateNoteComponent, { size: 'xs' as 'lg', centered: true });
    modalRef.componentInstance.noteforCandidate = this.candidatedata.basicdetails[0]
    modalRef.componentInstance.passEntry.subscribe((x) => {
      if (x == 'noteAdded') {
        this.toastmessage('Notes Added for Selected Candidate Succesfully', 'success')
        let data = {
          start: 0,
          candidatenumber: this.candidatedata.basicdetails[0].candidatenumber
        }
        this.passEntryEvent.emit('deleted')
        // this.selectAll(false)
      } else if (x == 'error') {
        this.toastmessage('Something Wrong, Please try again in a minute', 'error')
      }
    })
  }

  deletenote(note) {
      const modalRef = this.modalService.open(this.successModal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
      this.statusMessage = 'Are you sure you want to delete note?'
      this.deletenotedata = note
  }

  deletenotesmodal() {
    let payload = {
      candidatenumber: this.candidatedata.basicdetails[0].candidatenumber,
      noteid: this.deletenotedata.candidatenoteid
    }
    this.candidateservice.archivecandidatesnotes(payload).subscribe((res:any)=>{
      if(res.status == "success") {
        this.modalService.dismissAll()
        this.passEntryEvent.emit('deleted')

        this.toastmessage('Notes deleted successfully', 'success')
      } else {
        this.toastmessage('Something went wrong', 'success')
      }
    
    })

  }
}
